<div
    [id]="widget().id"
    [attr.data-raw-id]="widget().id"
    [style.--widget-visibility]="widgetVisibility()"
    [style.--widget-opacity]="widgetOpacity()"
    [style.--widget-top]="widgetTop()"
    [style.--widget-bottom]="widgetBottom()"
    [style.--widget-left]="widgetLeft()"
    [style.--widget-right]="widgetRight()"
    [style.--widget-width]="widgetWidth()"
    [style.--widget-height]="widgetHeight()"
    [style.--widget-z-index]="widgetZIndex()"
    class="widget widget-position click-outside-close-prevent"
    [class.active]="isWidgetSelected() && extendedWidgetParams()?.hasSetting"
    [class.active-more-action]="isShowMoreActionState()"
    [attr.data-boundary-target]="isDragging() ? undefined : true"
    [tooltip]="rotateTooltipTpl"
    [tooltipAppendToBody]="true"
    [isOpen]="isRotating()"
    triggers=""
    cdkDrag
    [cdkDragDisabled]="!canDrag()"
    (cdkDragStarted)="dragStarted()"
    (cdkDragMoved)="dragMoved($event)"
    (cdkDragEnded)="dragEndedTest()"
    (dblclick)="dblClickHandler()"
    (focusout)="blurHandler()"
    tabindex="0"
>
    <ng-template #rotateTooltipTpl>{{ rotateValue() }}°</ng-template>

    @if (showTopBoundary()) {
        <div
            style="position: absolute; background-color: red; height: 1px"
            [style.left]="0"
            [style.right]="0"
            [style.top]="0"
            [style.z-index]="zIndexValue() + 1"
        ></div>
    }
    @if (showVerticalCenterBoundary()) {
        <div
            style="position: absolute; background-color: red; height: 1px"
            [style.left]="0"
            [style.right]="0"
            [style.top.px]="centerY()"
            [style.z-index]="zIndexValue() + 1"
        ></div>
    }
    @if (showBottomBoundary()) {
        <div
            style="position: absolute; background-color: red; height: 1px"
            [style.left]="0"
            [style.right]="0"
            [style.bottom]="0"
            [style.z-index]="zIndexValue() + 1"
        ></div>
    }
    @if (showLeftBoundary()) {
        <div
            style="position: absolute; background-color: red; width: 1px"
            [style.top]="0"
            [style.bottom]="0"
            [style.left]="0"
            [style.z-index]="zIndexValue() + 1"
        ></div>
    }
    @if (showHorizontalCenterBoundary()) {
        <div
            style="position: absolute; background-color: red; width: 1px"
            [style.top]="0"
            [style.bottom]="0"
            [style.left.px]="centerX()"
            [style.z-index]="zIndexValue() + 1"
        ></div>
    }
    @if (showRightBoundary()) {
        <div
            style="position: absolute; background-color: red; width: 1px"
            [style.top]="0"
            [style.bottom]="0"
            [style.right]="0"
            [style.z-index]="zIndexValue() + 1"
        ></div>
    }

    @if (showWidget()) {
        <div class="info-label-container">
            @if (hideOnDesktopValue() && hideOnMobileValue()) {
                <div class="info-label" [tooltip]="tooltipAll" [tooltipAppendToBody]="true">
                    <img
                        src="./assets/img/websites/lpc-hidden-all-label-icon.svg"
                        [alt]="'control_widget_hidden_to_all' | translate"
                    />
                    <ng-template #tooltipAll>
                        {{ "control_widget_hidden_to_all" | translate }}
                    </ng-template>
                </div>
            }
            @if (hideOnMobileValue() && !hideOnDesktopValue()) {
                <div class="info-label" [tooltip]="tooltipMobile" [tooltipAppendToBody]="true">
                    <img
                        src="./assets/img/websites/lpc-hidden-mobile-label-icon.svg"
                        [alt]="'control_widget_hidden_mobile' | translate"
                    />
                    <ng-template #tooltipMobile>
                        {{ "control_widget_hidden_mobile" | translate }}
                    </ng-template>
                </div>
            }
            @if (hideOnDesktopValue() && !hideOnMobileValue()) {
                <div class="info-label" [tooltip]="tooltipDesktop" [tooltipAppendToBody]="true">
                    <img
                        src="./assets/img/websites/lpc-hidden-desktop-label-icon.svg"
                        [alt]="'control_widget_hidden_desktop' | translate"
                    />
                    <ng-template #tooltipDesktop>
                        {{ "control_widget_hidden_desktop" | translate }}
                    </ng-template>
                </div>
            }
        </div>
    }

    <div
        #targetElement
        class="widget-content"
        [class.widget-boundary]="isWidgetSelected()"
        [style.--content-width.px]="widthValue()"
        [style.--content-height.px]="heightValue()"
        [style.--content-rotate.deg]="rotateValue()"
    >
        <web-view-resolver [widget]="widget()"></web-view-resolver>

        @if (isWidgetSelected()) {
            @if (!isDragging() && canChangeWidgetHeight()) {
                <div
                    [tooltip]="heightValue() + 'px'"
                    [placement]="'top'"
                    class="resize-handler top-handler"
                    webResizeVerticalHandle
                    [targetElement]="targetElement"
                    [rotation]="rotateValue()"
                    direction="top"
                    (heightChangeStart)="heightChangeStart()"
                    (heightChange)="heightChangeToTop($event)"
                    (heightChangeEnd)="heightChangeEnd()"
                >
                    <div class="inner"></div>
                </div>
            }
            @if (!isDragging() && canChangeWidgetHeight() && canChangeWidgetWidth()) {
                <div
                    [tooltip]="heightValue() + 'px ' + widthValue() + 'px'"
                    [placement]="'top'"
                    class="resize-handler top-right-handler"
                    webResizeCornerHandle
                    direction="top-right"
                    [targetElement]="targetElement"
                    [keepProportions]="keepProportions()"
                    [rotation]="rotateValue()"
                    (sizeChangeStart)="sizeChangeStart()"
                    (sizeChange)="sizeChangeTopRight($event)"
                    (sizeChangeEnd)="sizeChangeEnd()"
                >
                    <div class="inner"></div>
                </div>
            }
            @if (!isDragging() && canChangeWidgetWidth()) {
                <div
                    [tooltip]="widthValue() + 'px'"
                    [placement]="'right'"
                    class="resize-handler right-handler"
                    webHorizontalResizeHandle
                    [targetElement]="targetElement"
                    [rotation]="rotateValue()"
                    direction="right"
                    (widthChangeStart)="widthChangeStart()"
                    (widthChange)="widthChangeToRight($event)"
                    (widthChangeEnd)="widthChangeEnd()"
                >
                    <div class="inner"></div>
                </div>
            }
            @if (!isDragging() && canChangeWidgetHeight() && canChangeWidgetWidth()) {
                <div
                    [tooltip]="heightValue() + 'px ' + widthValue() + 'px'"
                    [placement]="'bottom'"
                    class="resize-handler bottom-right-handler"
                    webResizeCornerHandle
                    direction="bottom-right"
                    [targetElement]="targetElement"
                    [keepProportions]="keepProportions()"
                    [rotation]="rotateValue()"
                    (sizeChangeStart)="sizeChangeStart()"
                    (sizeChange)="sizeChangeBottomRight($event)"
                    (sizeChangeEnd)="sizeChangeEnd()"
                >
                    <div class="inner"></div>
                </div>
            }
            @if (!isDragging() && canChangeWidgetHeight()) {
                <div
                    [tooltip]="heightValue() + 'px'"
                    [placement]="'bottom'"
                    class="resize-handler bottom-handler"
                    webResizeVerticalHandle
                    [targetElement]="targetElement"
                    [rotation]="rotateValue()"
                    direction="bottom"
                    (heightChangeStart)="heightChangeStart()"
                    (heightChange)="heightChangeToBottom($event)"
                    (heightChangeEnd)="heightChangeEnd()"
                >
                    <div class="inner"></div>
                </div>
            }
            @if (!isDragging() && canChangeWidgetHeight() && canChangeWidgetWidth()) {
                <div
                    [tooltip]="heightValue() + 'px ' + widthValue() + 'px'"
                    [placement]="'bottom'"
                    class="resize-handler bottom-left-handler"
                    webResizeCornerHandle
                    direction="bottom-left"
                    [targetElement]="targetElement"
                    [keepProportions]="keepProportions()"
                    [rotation]="rotateValue()"
                    (sizeChangeStart)="sizeChangeStart()"
                    (sizeChange)="sizeChangeBottomLeft($event)"
                    (sizeChangeEnd)="sizeChangeEnd()"
                >
                    <div class="inner"></div>
                </div>
            }
            @if (!isDragging() && canChangeWidgetWidth()) {
                <div
                    [tooltip]="widthValue() + 'px'"
                    [placement]="'left'"
                    class="resize-handler left-handler"
                    webHorizontalResizeHandle
                    [targetElement]="targetElement"
                    [rotation]="rotateValue()"
                    direction="left"
                    (widthChangeStart)="widthChangeStart()"
                    (widthChange)="widthChangeToLeft($event)"
                    (widthChangeEnd)="widthChangeEnd()"
                >
                    <div class="inner"></div>
                </div>
            }
            @if (!isDragging() && canChangeWidgetHeight() && canChangeWidgetWidth()) {
                <div
                    [tooltip]="heightValue() + 'px ' + widthValue() + 'px'"
                    [placement]="'top'"
                    class="resize-handler top-left-handler"
                    webResizeCornerHandle
                    direction="top-left"
                    [targetElement]="targetElement"
                    [keepProportions]="keepProportions()"
                    [rotation]="rotateValue()"
                    (sizeChangeStart)="sizeChangeStart()"
                    (sizeChange)="sizeChangeTopLeft($event)"
                    (sizeChangeEnd)="sizeChangeEnd()"
                >
                    <div class="inner"></div>
                </div>
            }
            @if (!isDragging()) {
                <div
                    [tooltip]="isRotating() ? undefined : rotateValue() + '°'"
                    [tooltipAppendToBody]="true"
                    class="rotate-handler"
                    webRotationHandler
                    [rotation]="rotateValue()"
                    [targetElement]="targetElement"
                    (rotationChangeStart)="rotationChangeStart()"
                    (rotationChange)="rotationChange($event)"
                    (rotationChangeEnd)="rotationChangeEnd()"
                >
                    <div class="inner"></div>
                </div>
            }
        }
    </div>

    @if (hideControls() && showWidget() && !isRotating()) {
        <web-zero-widget-controls
            class="widget-controls"
            [widgetName]="widget().name"
            [selectActionTooltip]="'control_widget_settings' | translate"
            [disableCopyEvent]="widget().name === Widgets.SHOP_CART"
            [disableRemoveEvent]="widget().name === Widgets.SHOP_CART"
            (copyEvent)="copyWidget()"
            (deleteEvent)="removeWidget()"
            (selectEvent)="selectWidget()"
            (toggleMoreActionState)="setMoreActionState($event)"
        />
        @if (!canDrag()) {
            <web-drag-handle class="drag-handle" cdkDragHandle></web-drag-handle>
        } @else {
            <web-drag-handle class="drag-handle"></web-drag-handle>
        }
        @if (extendedWidgetParams()?.showControls) {
            <div
                class="edit-widget-control"
                [title]="'control_widget_settings' | translate"
                (click)="selectWidget()"
                [style.z-index]="zIndexValue() + 1"
            >
                <span class="sp-icon icon-ap-edit"></span>
            </div>
        }
    }

    @if (widgetErrors() && !isWidgetSelected()) {
        <span class="sp-icon icon-warning warning-element"></span>
    }
</div>

@if (isDragging() || isKeyboardMoving()) {
    @if (topYValue() !== undefined) {
        <div
            [style.left.px]="leftXValue()"
            [style.right.px]="rightXValue()"
            [style.top.px]="topYValue()! < 0 ? topYValue() : null"
            [style.height.px]="topYValue()! < 0 ? -topYValue()! : topYValue()"
            class="position-guideline top"
        >
            <span [style.bottom.px]="guidelineTopLabelPosition()">{{ topYValue()!.toFixed() }}px</span>
        </div>
    }
    @if (bottomYValue() !== undefined) {
        <div
            [style.left.px]="leftXValue()"
            [style.right.px]="rightXValue()"
            [style.bottom.px]="bottomYValue()! < 0 ? bottomYValue() : null"
            [style.height.px]="bottomYValue()! < 0 ? -bottomYValue()! : bottomYValue()"
            class="position-guideline bottom"
        >
            <span [style.top.px]="guidelineBottomLabelPosition()">{{ bottomYValue()!.toFixed() }}px</span>
        </div>
    }
    @if (leftXValue() !== undefined) {
        <div
            [style.top.px]="topYValue()"
            [style.bottom.px]="bottomYValue()"
            [style.left.px]="leftXValue()! < 0 ? leftXValue() : null"
            [style.width.px]="leftXValue()! < 0 ? -leftXValue()! : leftXValue()"
            class="position-guideline left"
        >
            <span [style.right.px]="guidelineLeftLabelPosition()">{{ leftXValue()!.toFixed() }}px</span>
        </div>
    }
    @if (rightXValue() !== undefined) {
        <div
            [style.top.px]="topYValue()"
            [style.bottom.px]="bottomYValue()"
            [style.right.px]="rightXValue()! < 0 ? rightXValue() : null"
            [style.width.px]="rightXValue()! < 0 ? -rightXValue()! : rightXValue()"
            class="position-guideline right"
        >
            <span [style.left.px]="guidelineRightLabelPosition()">{{ rightXValue()!.toFixed() }}px</span>
        </div>
    }
}
